export default __webpack_public_path__ + "static/media/liquidity-mining-thumbnail.f431e668.svg";